import React from 'react'
import useOrbitFlag from 'hooks/useOrbitFlag'

function FaberFeatureToggle({
  feature,
  activeComponent,
  inactiveComponent
}: FlagProps) {
  const flagEnabled = useOrbitFlag(feature)

  return flagEnabled ? (
    <>{activeComponent}</>
  ) : (
    <>{inactiveComponent ? inactiveComponent : null}</>
  )
}

export default FaberFeatureToggle
interface FlagProps {
  feature: string
  activeComponent: JSX.Element
  inactiveComponent?: JSX.Element | undefined
}
